import React from "react";
import ModalWrapper from "common/ui/Modal";

interface ConfirmErpIdModalProps {
    erpId: string;
    onClose: () => void;
    onConfirm: () => Promise<void>;
}

const ConfirmErpIdModal: React.FC<ConfirmErpIdModalProps> = (props: ConfirmErpIdModalProps) => {
    return <ModalWrapper
        title="Confirm ERP ID"
        onAdvance={props.onConfirm}
        onCancel={props.onClose}
        advanceButtonText="Confirm"
        async>
        <div className="mt-2 h4 font-weight-bold text-center">
            {props.erpId}
        </div>
        <div className="mt-3 text-center">
            This will link the contract to the ERP system.
        </div>
    </ModalWrapper>
};

export default ConfirmErpIdModal;